import React, { useCallback } from 'react'
import styled from 'styled-components'
import { IconArrowLeft } from '@loadsmart/icons'

import BaseBustton from 'components/Button'

import { ButtonContainer } from './styles'

const Button = styled(BaseBustton)`
  :disabled {
    opacity: 0.5;
  }
`

interface Props {
  step: number
  canAdvance: boolean
  canGoBack: boolean
  setStep(step: number): void
  components: any[]
}

export default function Pager({
  step,
  setStep,
  canAdvance,
  canGoBack,
  components,
}: Props) {
  const handlePrevious = useCallback(
    (e) => {
      e.stopPropagation()
      e.preventDefault()
      setStep(step - 1)
    },
    [step, setStep]
  )
  const handleNext = useCallback(
    (e) => {
      e.stopPropagation()
      e.preventDefault()
      setStep(step + 1)
    },
    [step, setStep]
  )
  return (
    <ButtonContainer>
      {step > 0 ? (
        <Button
          variant="secondary"
          onClick={handlePrevious}
          disabled={!canGoBack}
        >
          <IconArrowLeft width={13} height={13} />
          &nbsp;Back
        </Button>
      ) : (
        <div />
      )}
      {step < components.length - 1 ? (
        <Button
          type="button"
          variant="main"
          onClick={handleNext}
          disabled={!canAdvance}
        >
          Next
        </Button>
      ) : (
        <Button type="submit" variant="main" disabled={!canAdvance}>
          Finish
        </Button>
      )}
    </ButtonContainer>
  )
}
